import { IconButton } from "@circle-react-shared/uikit/HeaderV3/IconButton";
import { EmojiPickerV3 } from "@circle-react-uikit/EmojiPickerV3";
import { Portal } from "@circle-react-uikit/Portal";

import { t } from "@/i18n-js/instance";

export const CaptionToolbar = ({ editor, portalId }: any) => {
  if (!editor) {
    return null;
  }

  return (
    <Portal selectorQuery={`#${portalId}`}>
      <div className="flex items-center md:pt-2">
        <EmojiPickerV3
          popoverPanelClassName="md:!w-[21rem]"
          onEmojiSelect={emojiData =>
            editor.chain().focus().insertContent(emojiData.emoji).run()
          }
          targetWrapperClassName="!flex"
          target={
            <IconButton
              iconSize={20}
              buttonSize={28}
              iconClassName="!text-dark !w-6 !h-6"
              name="20-emoji"
              ariaLabel={t("emoji_picker")}
            />
          }
        />
      </div>
    </Portal>
  );
};
